module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "exposures-carousel",
    attrs: {
      "id": "exposures-carousel"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "carousel-items"
  }, _vm._l((_vm.filteredExposures), function(exposure, index) {
    return _c('div', {
      staticClass: "carousel-item",
      on: {
        "click": function($event) {
          _vm.getExposure(exposure.exposure_slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": exposure.mobile.gridImageX1,
        "srcset": (exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(exposure.exposure_label)
      }
    })])])
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06688970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExposuresCarousel.vue
// module id = 443
// module chunks = 1